export default __webpack_public_path__ + "static/green-banner-9d70008f499f3b08f2220b86dbdc4066.svg";